function calculateTotalPackagePrice(packagePrice: number, numberOfGuest: number): number {

  if (numberOfGuest <= 0) {
    throw new Error("Number of guests must be greater than 0.");
  }
  const totalPrice = packagePrice * numberOfGuest;
  let discount = 0;
  const currentDate = new Date();
  const cutoffDate = new Date("2025-02-28T23:59:59");

  if (process.env.REACT_APP_PROJECT_COUNTRY === "uk") {
    // if (currentDate < cutoffDate) {
      // Discount applied until Feb 28, 2025
      // if (totalPrice >= 10000) {
      //   discount = 400;
      // } else if (totalPrice >= 7500) {
      //   discount = 300;
      // } else if (totalPrice >= 5000) {
      //   discount = 200;
      // }
      // else if (totalPrice >= 4000) {
      //   discount = 150;
      // }
      // else if (totalPrice >= 3000) {
      //   discount = 100;
      // }
      // else if (totalPrice >= 2000) {
      //   discount = 50;
      // }
    // } 
    // else {
    // New discount structure starting from March 1, 2025
    discount = 100;
    // }

  } else if (`${process.env.REACT_APP_PROJECT_COUNTRY}` === "ie") {
    // if (totalPrice >= 10000) {
    //   discount = 400;
    // } else if (totalPrice >= 7500) {
    //   discount = 300;
    // } else if (totalPrice >= 5000) {
    //   discount = 200;
    // }
    // else if (totalPrice >= 4000) {
    //   discount = 150;
    // }
    // else if (totalPrice >= 3000) {
    //   discount = 100;
    // }
    // else if (totalPrice >= 2000) {
    //   discount = 50;
    // }
    discount = 100;
  }
  return totalPrice - discount;
}

export function calculatePerPersonPrice(packagePrice: number, numberOfGuest: number): number {
  if (numberOfGuest <= 0) {
    throw new Error("Number of guests must be greater than 0.");
  }

  // Calculate total price after discount
  const totalPriceAfterDiscount = calculateTotalPackagePrice(packagePrice, numberOfGuest);

  // Calculate per-person price
  const perPersonPrice = totalPriceAfterDiscount / numberOfGuest;

  return perPersonPrice;
}
